<fieldset>
  <legend>
    @if (singleTeamMember) {
      <span class="screen-reader-only">{{'ClassEnrolment.LearnerDetails' | translate}}</span>
    }
    @if (!singleTeamMember) {
      <span class="screen-reader-only">{{'ClassEnrolment.Learner' | translate}} {{learnerNumber+1}} {{'ClassEnrolment.Details' | translate}}</span>
    }
  </legend>
  <div [class.box]="!singleTeamMember" [class.plain-style]="singleTeamMember"
    [class.ontario-padding-top-16-!]="singleTeamMember">

    @if (!singleTeamMember) {
      <div class="row ontario-row">
        <div class="add-learner-row ontario-column ontario-small-12 ontario-medium-8 ontario-large-8 add-learner-header">
          <h4>
            {{'ClassEnrolment.Learner' | translate}} {{learnerNumber+1}} {{'ClassEnrolment.Details' | translate}}
            <span [class.required-field]="learnerInforRequired"></span>
          </h4>
        </div>
        <div class="add-learner-row ontario-column ontario-small-12 ontario-medium-4 ontario-large-4">
          <button [class.expanded]="expanded" style="float: right !important" (click)="expanded = !expanded;">
            @if (!expanded) {
              <img alt="expand" src="assets/images/chevron-down-white-border-grey-background.svg">
            }
            @if (expanded) {
              <img alt="collapse" src="assets/images/chevron-down-white-border-grey-background.svg">
            }
          </button>
        </div>
      </div>
    }
    @if (expanded) {
      @if (!singleTeamMember) {
        <div class="row ontario-row border-bottom border-bottom-margin"></div>
      }
      @if (!singleTeamMember) {
        <div class="add-learner-row row ontario-row">
          {{'Contact.LearnerHasToProvidePersonalContactDetail' | translate}}
        </div>
      }
      <form [formGroup]="newLearnerForm">
        @if (learnerInforRequired && !singleTeamMember) {
          <div class="add-learner-checkbox-row row ontario-row">
            <div class="add-team-member-row ontario-column ontario-small-12 ontario-medium-11 ontario-large-11">
              <app-checkbox [name]="'ClassEnrolment.sameAsPrimaryContact' | translate"
                [disabled]="DisableSameAsPrimaryContact" [checked]="inforSameAsPC"
                (checkedChange)="CopyInfoFromPrimaryContact($event)">
              </app-checkbox>
            </div>
          </div>
        }
        <div class="add-learner-row row ontario-row">
          <div class="ontario-column ontario-small-12 ontario-medium-7 ontario-large-7">
            <mat-label class="input-label">
              <span [class.required-field]="learnerInforRequired">
                {{'Contact.EmailAddress' | translate}}
              </span>
            </mat-label>
            <input autocomplete="email" type="email" class='input-text' formControlName="emailAddress" matInput maxlength="320"
              [attr.aria-label]="'ClassEnrolment.EmailAddress' | translate" [class.disabled]="inforSameAsPC"
              [readonly]="inforSameAsPC"
              [required]="learnerInforRequired" (ngModelChange)="learnerDetail.emailAddress = $event;"
              (blur)="validateEmailExists.emit()" placeholder="{{'Contact.EmailAddressTooltip' | translate}}" />
              @if (((newLearnerForm.controls['emailAddress'].invalid || newLearnerForm.controls['emailAddress'].errors) &&
                (newLearnerForm.controls['emailAddress'].dirty || newLearnerForm.controls['emailAddress'].touched))) {
                <div role="alert"
                  >
                  @if (newLearnerForm.controls['emailAddress'].hasError('required')) {
                    <mat-error>
                      {{'Validation.Email.PoliteRequired' | translate}}
                    </mat-error>
                  }
                  @if (newLearnerForm.controls['emailAddress'].hasError('pattern')) {
                    <mat-error>
                      {{'Validation.Email.Pattern' | translate}}
                    </mat-error>
                  }
                  @if (newLearnerForm.controls['emailAddress'].hasError('exists')) {
                    <mat-error>
                      {{'CreateClassroom.Validation.EmailAddressExists' | translate}}
                    </mat-error>
                  }
                  @if (newLearnerForm.controls['emailAddress'].hasError('currentTpUser')) {
                    <mat-error>
                      {{'CreateClassroom.Validation.CurrentTpUser' | translate}}
                    </mat-error>
                  }
                </div>
              }
            </div>
          </div>
          <div class="add-learner-row row ontario-row">
            <div class="ontario-column ontario-small-12 ontario-medium-7 ontario-large-7">
              <mat-label class="input-label">
                <span [class.required-field]="learnerInforRequired">
                  {{'Contact.FirstName' | translate}}
                </span>
              </mat-label>
              <input autocomplete="given-name" type="text" class='input-text' formControlName="firstName" matInput maxlength="250"
                [attr.aria-label]="'Contact.FirstName' | translate" [class.disabled]="inforSameAsPC"
                [readonly]="inforSameAsPC"
                [required]="learnerInforRequired" (ngModelChange)="learnerDetail.firstName = $event;"
                placeholder="{{'Contact.FirstNameTooltip' | translate}}" />
                @if ((newLearnerForm.controls['firstName'].invalid &&  newLearnerForm.controls['firstName'].errors &&
                  (newLearnerForm.controls['firstName'].dirty || newLearnerForm.controls['firstName'].touched))) {
                  <div role="alert"
                    >
                    @if (newLearnerForm.controls['firstName'].hasError('required')) {
                      <mat-error>
                        {{'Validation.FirstName.Required' | translate}}
                      </mat-error>
                    }
                    @if (newLearnerForm.controls['firstName'].hasError('maxlength')) {
                      <mat-error>
                        {{'Validation.FirstName.MaxLength' | translate}}
                      </mat-error>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="add-learner-row row ontario-row">
              <div class="ontario-column ontario-small-12 ontario-medium-7 ontario-large-7">
                <mat-label class="input-label">
                  <span [class.required-field]="learnerInforRequired">{{'Contact.LastName' | translate}}</span>
                </mat-label>
                <input autocomplete="family-name" type="text" class='input-text' formControlName="lastName" matInput [class.disabled]="inforSameAsPC"
                  [readonly]="inforSameAsPC"
                  [required]="learnerInforRequired" (ngModelChange)="learnerDetail.lastName = $event;" maxlength="250"
                  placeholder="{{'Contact.LastNameTooltip' | translate}}"
                  [attr.aria-label]="'Contact.LastName' | translate" />
                  @if ((newLearnerForm.controls['lastName'].invalid &&  newLearnerForm.controls['lastName'].errors &&
                    (newLearnerForm.controls['lastName'].dirty || newLearnerForm.controls['lastName'].touched))) {
                    <div role="alert"
                      >
                      @if (newLearnerForm.controls['lastName'].hasError('required')) {
                        <mat-error>
                          {{'Validation.LastName.Required' | translate}}
                        </mat-error>
                      }
                      @if (newLearnerForm.controls['lastName'].hasError('maxlength')) {
                        <mat-error>
                          {{'Validation.LastName.MaxLength' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="add-learner-row row ontario-row">
                <div class="ontario-column ontario-small-12 ontario-medium-7 ontario-large-7">
                  <mat-label class="input-label">
                    <span [class.required-field]="learnerInforRequired">{{'Contact.Phone' | translate}}</span>
                  </mat-label>
                  <input autocomplete="tel" type="text" mask="000-000-0000" class='input-text' formControlName="phone" matInput
                    [class.disabled]="inforSameAsPC" [required]="learnerInforRequired"
                    [readonly]="inforSameAsPC"
                    [attr.aria-label]="'Contact.Phone' | translate" (ngModelChange)="learnerDetail.phoneNumber = $event;"
                    placeholder="{{'Contact.PhoneTooltip' | translate}}" />
                    @if ((newLearnerForm.controls['phone'].invalid &&  newLearnerForm.controls['phone'].errors &&
                      (newLearnerForm.controls['phone'].dirty || newLearnerForm.controls['phone'].touched))) {
                      <div role="alert">
                        @if (newLearnerForm.controls['phone'].hasError('required')) {
                          <mat-error>
                            {{'Validation.Phone.PoliteRequired' | translate}}
                          </mat-error>
                        }
                        @if (newLearnerForm.controls['phone'].hasError('maxlength')) {
                          <mat-error>
                            {{'Validation.Phone.MaxLength' | translate}}
                          </mat-error>
                        }
                        @if (newLearnerForm.controls['phone'].hasError('pattern')) {
                          <mat-error>
                            {{'Validation.Phone.Pattern' | translate}}
                          </mat-error>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="add-learner-row row ontario-row">
                  <div class="ontario-column ontario-small-12 ontario-medium-7 ontario-large-7">
                    <mat-label class="input-label">
                      <span [class.required-field]="learnerInforRequired"> {{'ClassEnrolment.BirthYear' | translate}} </span>
                    </mat-label>
                    <input autocomplete="bday-year" type="text" class='input-text' formControlName="birthYear" matInput [required]="learnerInforRequired"
                      [attr.aria-label]="'ClassEnrolment.BirthYear' | translate"
                      (ngModelChange)="learnerDetail.birthYear = $event;" maxlength="4"
                      placeholder="{{'ClassEnrolment.EnterBirthYear' | translate}}" />
                      @if ((newLearnerForm.controls['birthYear'].invalid &&  newLearnerForm.controls['birthYear'].errors &&
                        (newLearnerForm.controls['birthYear'].dirty || newLearnerForm.controls['birthYear'].touched))) {
                        <div role="alert"
                          >
                          @if (newLearnerForm.controls['birthYear'].hasError('pattern')) {
                            <mat-error>
                              {{'Validation.BirthYear.Pattern' | translate}}
                            </mat-error>
                          }
                          @if (newLearnerForm.controls['birthYear'].hasError('required')) {
                            <mat-error>
                              {{'Validation.BirthYear.Required' | translate}}
                            </mat-error>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </form>
                <div class="ontario-padding-top-16-!">
                  @if (singleTeamMember && !isTPEdit) {
                    <app-eligibility-checker [isSingleTeamMember]="true"
                    [courseDto]="courseDto"></app-eligibility-checker>
                  }
                </div>
                @if (learnerInforRequired && !isTPEdit) {
                  <div class="subscription" [class.box]="singleTeamMember"
                    [class.ontario-margin-top-0-!]="singleTeamMember">
                    <div class="row ontario-row">
                      <h4 class="border-bottom">
                        {{'Contact.Subscription' | translate}}
                      </h4>
                    </div>
                    <div class="add-learner-checkbox-row row ontario-row">
                      <div [class.ontario-margin-left-8-!]="!singleTeamMember" class="ontario-column ontario-small-12 ontario-medium-11 ontario-large-11">
                        <app-checkbox [name]="'Contact.OptinForEmail' | translate" [(checked)]="learnerDetail.optinforEmail!"></app-checkbox>
                      </div>
                    </div>
                    <div class="add-learner-checkbox-row row ontario-row">
                      <div [class.ontario-margin-left-8-!]="!singleTeamMember" class="ontario-column ontario-small-12 ontario-medium-11 ontario-large-11">
                        <app-checkbox [name]="'Contact.OptinForSMS' | translate" [(checked)]="learnerDetail.optinforSMS!"></app-checkbox>
                      </div>
                    </div>
                  </div>
                }
                @if (!singleTeamMember && isTPEdit && learnerDetail.registrationId == undefined && !(disableDelete && isTPEdit)) {
                  <div class="row ontario-row border-bottom border-bottom-margin"></div>
                  <div class="add-learner-button-row row ontario-row">
                    <button class="grey-button" (click)="DeleteLearner()" [disabled]="disableDelete">
                      {{'Contact.Delete' | translate}}
                    </button>
                  </div>
                }
              }
            </div>
          </fieldset>
          @if (!singleTeamMember && showEligibilityChecker) {
            <div class="eligibility-box">
              @if (!isTPEdit) {
                <app-eligibility-checker [courseDto]="courseDto" [isSingleTeamMember]="false"
                #multiLearnerEligibilityChecker></app-eligibility-checker>
              }
            </div>
          }